/* eslint-disable @typescript-eslint/camelcase */

import { useState, useCallback } from 'react';
import { Status } from 'hooks/requests/fetchUtils';
import useFetchApi from 'hooks/useFetchApi';
import useQueryParameters from 'hooks/useQueryParameters';
import { setExpireTime } from 'state/otpCode';
import { useDispatch } from 'react-redux';
// TODO: correct this path
const PATH = '/api/otp';

type OTPSenderHook = () => [
  ({ phone }: { phone: string }) => Promise<void>,
  Status,
  string | null,
];

export class OTPSenderError extends Error {}

export const useOTPSender: OTPSenderHook = () => {
  const dispatch = useDispatch();
  const [error, setError] = useState<string | null>(null);
  const [status, fetch] = useFetchApi();
  const { mockSOTP } = useQueryParameters();

  const sendOTP = useCallback(
    async ({ phone }: { phone: string }): Promise<void> => {
      setError(null);

      const response = await fetch(PATH, {
        method: 'POST',
        body: { phone: phone, mockOtpResponse: mockSOTP },
      });

      if (!response.ok) {
        const body = await response.json();
        const error = body.message;
        setError(error);
        return Promise.reject(new OTPSenderError(error));
      } else {
        dispatch(setExpireTime());
      }
    },
    [fetch, mockSOTP, dispatch],
  );

  return [sendOTP, status, error];
};

export default useOTPSender;
